import { render, staticRenderFns } from "./PaginatorTop.vue?vue&type=template&id=2277add0&scoped=true"
import script from "./PaginatorTop.vue?vue&type=script&lang=js"
export * from "./PaginatorTop.vue?vue&type=script&lang=js"
import style0 from "./PaginatorTop.vue?vue&type=style&index=0&id=2277add0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2277add0",
  null
  
)

export default component.exports